<template>
  <div class="tuolele-main-box set-combo">
    <div class="tuolele-main-search">
      <el-button type="success" @click="fnCreateActive()">创建活动</el-button>
    </div>
    <div class="tuolele-main-content">
      <el-table :data="activeLists" border>
        <el-table-column prop="name" label="学生姓名" />
        <el-table-column prop="begin_day" label="游学时间" />
        <el-table-column prop="day_type_name" label="全半天" />
        <el-table-column prop="num" label="参与人数" />
        <el-table-column label="课耗总和">
          <template slot-scope="scope">
            {{ scope.row.course_cost/100 }}
          </template>
        </el-table-column>
        <el-table-column prop="cost" label="活动成本">
          <template slot-scope="scope">
            {{ scope.row.cost/100 }}
          </template>
        </el-table-column>
        <el-table-column prop="profit" label="毛利润">
          <template slot-scope="scope">
            {{ scope.row.profit/100 }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="210">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="fnToDetail(scope.row.id)">查看详情</el-button>
            <el-dropdown size="mini" style="margin-left:10px">
              <el-button type="primary" size="mini">
                更多操作<i class="el-icon-arrow-down el-icon--right" />
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="popSetInfo(scope.row.id,scope.row.begin_day,'date')">修改活动时间</el-dropdown-item>
                <el-dropdown-item @click.native="popSetInfo(scope.row.id,scope.row.cost,'cost')">修改活动成本</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <div class="footer pagination-footer">
        <div class="block">
          <el-pagination
            layout="prev, pager, next, slot, jumper"
            :current-page.sync="listQuery.p"
            prev-text="上一页"
            next-text="下一页"
            :total="listQuery.total"
            :page-size="listQuery.limit"
            @current-change="fnGetLists"
          />
        </div>
      </div>
      <el-dialog title="新增活动" :visible.sync="dialogVisible" width="600px">
        <el-form ref="postForm" :model="postForm" :rules="rules">
          <el-form-item label="活动名称" prop="name">
            <el-input v-model="postForm.name" style="width: 400px;" placeholder="请输入内容" />
          </el-form-item>
          <el-form-item label="全天半天" prop="day_type">
            <el-radio-group v-model="postForm.day_type">
              <el-radio :label="1">半天</el-radio>
              <el-radio :label="2">全天</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="活动时间" prop="begin_day">
            <el-date-picker v-model="postForm.begin_day" value-format="yyyy-MM-dd" type="date" placeholder="选择日期" />
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="fnSubmit">确定</el-button>
        </span>
      </el-dialog>
      <el-dialog title="导入学生" :visible.sync="dialogImprove" width="600px">
        <improve-active-student :key="improveKey" :activity-id="activityId" @successCBK="fnGetLists()" />
      </el-dialog>
      <el-dialog title="修改信息" :visible.sync="dialogSetInfo" width="600px">
        <set-active-info :key="setKey" :last-data="acitvieLastData" :type="setType" :activity-id="activityId" @successCBK="fnGetLists()" />
      </el-dialog>
    </div>
  </div>
</template>
<script>
import Tool from '@/assets/js/tool.js'
import { validateRequire } from '@/utils/validate'
import improveActiveStudent from './components/ImpoveActiveStudent'
import setActiveInfo from './components/SetActiveInfo'
const defaultPostForm = {
  begin_day: '',
  name: '',
  day_type: 1
}

export default {
  name: 'StoreSetting',
  components: {
    improveActiveStudent,
    setActiveInfo
  },
  data() {
    return {
      dialogVisible: false,
      dialogImprove: false,
      dialogSetInfo: false,
      activityId: '',
      setType: 'date',
      acitvieLastData: '',
      improveKey: 999,
      setKey: 9999,
      listQuery: {
        total: 0,
        p: 1,
        limit: 20
      },
      postForm: Object.assign({}, defaultPostForm),
      activeLists: [],
      rules: {
        begin_day: [{ validator: validateRequire, trigger: 'manual', message: '开始时间' }],
        day_type: [{ validator: validateRequire, trigger: 'manual', message: '全半天' }],
        name: [{ validator: validateRequire, trigger: 'manual', message: '名称' }]
      }
    }
  },
  mounted() {
    this.fnGetLists()
  },
  methods: {
    fnGetLists() {
      this.dialogImprove = false
      this.dialogVisible = false
      this.dialogSetInfo = false
      this.$http.getActivityList(this.listQuery).then(res => {
        this.listQuery.total = parseInt(res.data.count)
        this.activeLists = res.data.list
      })
    },
    fnCreateActive() {
      this.dialogVisible = true
    },
    fnDelete(project_id) {
      this.$confirm('是否删除质检项目?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.delProject({ project_id }).then(() => {
          this.$message({
            type: 'success',
            message: '删除成功'
          })
          this.fnGetLists()
        })
      })
    },
    fnToDetail(id) {
      this.$router.push({
        path: 'activeYXStudentLists',
        query: { id: id }
      })
    },
    popImprove(id) {
      this.activityId = id
      this.improveKey++
      this.dialogImprove = true
    },
    popSetInfo(id, old, type) {
      this.activityId = id
      this.acitvieLastData = old
      this.setType = type
      this.setKey++
      this.dialogSetInfo = true
    },
    fnCreateProject(projectId) {
      this.postForm = Object.assign({}, defaultPostForm)
      this.dialogVisible = true
    },
    fnSubmit() {
      this.$refs.postForm.validate(valid => {
        if (valid) {
          this.$http.improveActivity(this.postForm).then(res => {
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: '添加成功'
              })
              this.$refs.postForm.resetFields()
              this.dialogVisible = false
              this.fnGetLists()
            }
          })
        }
      })
    },
    checkNameEmpty() {
      return Tool.findIndexInArryByKeyVal(this.postForm.project_lists, 'name', '') > -1
    }

  }
}
</script>
<style lang="scss">
  .wq_flex {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
}

.wq_flex_wrap {
  flex-wrap: wrap;
}

.wq_flex_sub {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
}

.set-combo {
  .self-table {
    margin-top: 0 !important;
  }
  .el-form-item__label {
    font-size: 16px;
    color: #333;
  }
  .el-form-item__content {
    margin: 0 20px 0 12px;
  }
  .el-button.el-button-confirm {
    width: 80px !important;
  }
}
</style>
